/**
 * @file request.js 网络请求工具
 */

import guid from '../guid';

const codeMessage = {
    200: '服务器成功返回请求的数据。',
    201: '新建或修改数据成功。',
    202: '一个请求已经进入后台排队（异步任务）。',
    204: '删除数据成功。',
    400: '参数有错误',
    401: '用户没有权限（令牌、用户名、密码错误）。',
    403: '用户得到授权，但是访问是被禁止的。',
    404: '发出的请求针对的是不存在的记录，服务器没有进行操作。',
    406: '请求的格式不可得。',
    410: '请求的资源被永久删除，且不会再得到的。',
    422: '当创建一个对象时，发生一个验证错误。',
    431: '请求头字段太长。',
    500: '服务器发生错误，请检查服务器。',
    502: '网关错误。',
    503: '服务不可用，服务器暂时过载或维护。',
    504: '网关超时。'
};

const checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const errortext = codeMessage[response.status] || response.statusText;
    const error = new Error(errortext);
    error.name = response.status;
    error.response = response;
    throw error;
};

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {Object} [option] The options we want to pass to "fetch"
 * @return {Object}           An object containing either "data" or "err"
 */
export default function request(url, option) {
    const options = {
        expirys: false,
        ...option
    };

    const defaultOptions = {
        credentials: 'include',
        redirect: 'manual'
    };
    const newOptions = {...defaultOptions, ...options};
    if (['GET', 'DELETE', 'PUT', 'POST'].includes(newOptions.method)) {
        if (!(newOptions.body instanceof FormData)) {
            newOptions.headers = {
                'Log-Id': guid(),
                'reqid': guid(),
                Accept: 'application/json',
                'Content-Type': 'application/json; charset=utf-8',
                ...newOptions.headers
            };
            if (newOptions.method !== 'GET') {
                newOptions.body = JSON.stringify(newOptions.body);
            }
        } else {
            // newOptions.body is FormData
            newOptions.headers = {
                'Log-Id': guid(),
                Accept: 'application/json',
                ...newOptions.headers
            };
        }
    }
    if (newOptions.headers == null) {
        newOptions.headers = {};
    }

    return fetch(url, newOptions)
        .then(checkStatus)
        .then(response => {
            if (newOptions.method === 'DELETE' || response.status === 204) {
                return response.text();
            }
            return response.json();
        })
        .catch(e => {
            const name = e.name;
            const message = e.message;

            return {
                status: -1,
                name,
                message
            };
        });
}
